import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatMinutes',
  standalone: true
})
export class FormatMinutesPipe implements PipeTransform {

  transform(totalMinutes: number): string {
    const rounded = Math.round(totalMinutes);
    const hours = Math.floor(rounded / 60);
    const minutes = rounded % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }
}
